export default function (title) {
  return title
    .split("class=textFontWeightBold").join("style=font-weight:bold;")

    .split("class=fontColorRed").join("style=color:red;")
    .split("class=fontColorWhite").join("style=color:white;")
    .split("class=fontColorKaratRed").join("style=color:#9F1D27;")
    .split("class=fontColorGrey").join("style=color:#C9C9C9;")
    .split("class=fontColorLightGrey").join("style=color:#ddd;")
    .split("class=fontColorGreen").join("style=color:#4cd964;")
    .split("class=fontColorDarkBlue").join("style=color:#2e5069;")

    .split("class=textAlignLeft").join("style=display:inline-block;width:100%;text-align:left;")
    .split("class=textAlignCenter").join("style=display:inline-block;width:100%;text-align:center;")
    .split("class=textAlignRight").join("style=display:inline-block;width:100%;text-align:right;")

    .split("class=textLineHeight10").join("style=line-height:10px;")
    .split("class=textLineHeight12").join("style=line-height:12px;")
    .split("class=textLineHeight14").join("style=line-height:14px;")
    .split("class=textLineHeight16").join("style=line-height:16px;")
    .split("class=textLineHeight18").join("style=line-height:18px;")
    .split("class=textLineHeight20").join("style=line-height:20px;")
    .split("class=textLineHeight22").join("style=line-height:22px;")
    .split("class=textLineHeight24").join("style=line-height:24px;")

    .split("class=fontSize26").join("style=font-size:26px;")
    .split("class=fontSize24").join("style=font-size:24px;")
    .split("class=fontSize22").join("style=font-size:22px;")
    .split("class=fontSize20").join("style=font-size:20px;")
    .split("class=fontSize18").join("style=font-size:18px;")
    .split("class=fontSize16").join("style=font-size:16px;")
    .split("class=fontSize14").join("style=font-size:14px;")
    .split("class=fontSize12").join("style=font-size:12px;")
    .split("class=fontSize10").join("style=font-size:10px;")
    .split("class=fontSize8").join("style=font-size:8px;")
    .split("class=fontSize6").join("style=font-size:6px;")
    .split("class=fontSize4").join("style=font-size:4px;")

}
